import { useFilingCabinetContext } from '@/Contexts/Authenticated/FilingCabinetContext';
import { type FilingCabinetItem } from '@/Models/FilingCabinet/FilingCabinet';
import FilingCabinetStore from '@/Stores/FilingCabinetStore';
import NewWordsStore from '@/Stores/NewWords/NewWordsStore';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Styles from '../NewWords/NewWordsPage.module.scss';
import NewWordsTabs from './Tabs/NewWordsTabs';

interface NewWordsPageProps {
    initialState: FilingCabinetItem;
}

const NewWordsPage = ({ initialState }: NewWordsPageProps): React.ReactElement => {
    const fcContext = useFilingCabinetContext();
    const newWordsStore = useMemo(() => new NewWordsStore(new FilingCabinetStore(initialState, fcContext)), [initialState]);
    return (<NewWords store={newWordsStore} />);
};

const NewWords = observer(({ store }: { store: NewWordsStore }): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <div className={Styles.newWords}>
            <h2>{t('NewWords')}</h2>
            <NewWordsTabs store={store} />
        </div>

    );
});

export default NewWordsPage;
